import type { CheckoutServiceParticipant } from '../../../domain/types'
import type {
  APIBookingDraft,
  APIBookingDraftParticipant,
  APIBookingDraftService,
  APIBookingDraftServiceOption,
} from '@/scopes/checkout/infrastructure/api/types'

export interface ServiceParticipantsMapper {
  map: (service: APIBookingDraftService) => Record<string, CheckoutServiceParticipant>[]
  mapParticipantWithAvailableOptions: (
    participant: APIBookingDraftParticipant,
    options: APIBookingDraftServiceOption[]
  ) => CheckoutServiceParticipant
}

export function createServiceParticipantsMapper() {
  function map(service: APIBookingDraftService, bookingDraft: APIBookingDraft) {
    const { options } = service as unknown as { options: APIBookingDraftServiceOption[] }

    return (
      bookingDraft?.participants.reduce(
        (acc, participant) => ({
          ...acc,
          [participant.id.toString()]: mapParticipantWithAvailableOptions(participant, options),
        }),
        {},
      ) ?? {}
    )
  }

  function mapParticipantWithAvailableOptions(
    participant: APIBookingDraftParticipant,
    options: APIBookingDraftServiceOption[],
  ) {
    return {
      id: participant.id.toString(),
      name: participant.name || participant.alternativeName?.toLowerCase() || '',
      roomId: participant.roomId.toString(),
      birthdate: participant.birthdate,
      ageCategory: participant?.ageCategory.toLowerCase(),
      selectedValue:
        options
          .filter(({ isSelected }) => isSelected)
          .find(({ assignedParticipants }) => assignedParticipants.includes(participant.id))
          ?.code || undefined,
      availableOptions: options
        .filter(({ appliesToParticipants }) => appliesToParticipants.includes(participant.id))
        .map(({ code }) => code),
    }
  }

  return { map, mapParticipantWithAvailableOptions }
}
